import React from 'react';
import Modal from 'components/ModalSecond';
import { SizedLongBody } from 'containers/LoginPage/styles';
import { injectIntl, useIntl } from 'react-intl';
import { Box, CircularProgress, useMediaQuery } from '@material-ui/core';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { translate } from 'helpers/intl';
import { OrangeButton } from 'components/Button';
import messages from './messages';

const ModalOrganisme = ({
  isOpen,
  openModalOrganisme,
  setAMCDetailsPageBreadcrumbsPath,
  setOrganisme,
  headerTitle,
  organismeList,
  ...props
}: any) => {
  const intl = useIntl();
  const isNotMobile = useMediaQuery('(min-width:960px)');
  const nextButtonWidth = isNotMobile ? 100 : 230;

  return (
    <Formik
      initialValues={{
        organisme: '',
      }}
      validationSchema={ProcessSchema(intl)}
      onSubmit={(values, actions) => {}}
    >
      {(FormikProps) => (
        <Modal
          open={isOpen}
          handleOpen={openModalOrganisme}
          handleClose={
            /* istanbul ignore next */ () => {
              FormikProps.resetForm();
              props.closeModalOrganismeChoice();
            }
          }
          header={
            <>
              <SizedLongBody weight="500" color="#FAFAFA">
                {headerTitle}
              </SizedLongBody>
            </>
          }
          content={props.content}
          footer={
            <>
              <Box
                component="span"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingTop: '16px',
                  paddingBottom: '16px',
                  paddingRight: '50px',
                  paddingLeft: '50px',
                }}
              >
                <OrangeButton
                  variant="contained"
                  color="secondary"
                  style={{ width: nextButtonWidth }}
                  onClick={
                    /* istanbul ignore next */ () => {
                      FormikProps.submitForm();
                      const selectedOrganisme = organismeList.find(
                        (o: any) =>
                          o.NUM_POLICE === FormikProps.values.organisme,
                      );
                      setOrganisme && setOrganisme(selectedOrganisme);
                      props.closeModalOrganismeChoice();
                    }
                  }
                  disabled={
                    Object.keys(FormikProps.errors).length > 0 ||
                    props.isLoading ||
                    FormikProps.values.organisme === ''
                  }
                >
                  {props.isLoading ? (
                    <CircularProgress size={20} />
                  ) : (
                    intl.formatMessage({ id: 'signup_auth_button.next' })
                  )}
                </OrangeButton>
              </Box>
            </>
          }
        />
      )}
    </Formik>
  );
};

const ProcessSchema = (intl: any) => {
  return [
    Yup.object().shape({
      organisme: Yup.string().required(
        translate({ ...messages.requiredField }, { intl }),
      ),
    }),
  ][intl];
};

export default injectIntl(ModalOrganisme);
